const ProductType = {
  LPG: "lpg",
  Lubes: "lubes",
  Fuel: "fuel",
};

export default ProductType;
